<template>
    <section>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <router-link
                            :to="{ name: 'disputes-report'}"
                            class="btn btn-primary btn-submit mr-50" target="_self"
                            v-if="userStore.user.isDiy"
                        >
                        Back
                        </router-link>
                        <a :href="$router.resolve({ name: 'disputes-report'}).href" class="btn btn-primary btn-submit mr-50" v-else>{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="creditBureaus.id" hidden>
                                <div id="editor">
                                    <div class="page">
                                        <p>
                                            {{ userInfo.firstname }} {{ userInfo.lastname }}
                                            <br /> {{ userInfo.address }}
                                            <br /> {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                                            <br /> {{ userInfo.ssn }}
                                            <br />
                                            <br /> {{ creditBureaus.address_name }}
                                            <br /> {{ creditBureaus.street_address }}
                                            <br /> {{ creditBureaus.city }}, {{ creditBureaus.state_abbrev }} {{ creditBureaus.zipcode }}
                                            <br />
                                            <br /> Date: {{ date }}
                                            <br />
                                            <br />
                                        </p>
                                        <p>
                                            <strong>ATTN:</strong>
                                            {{ creditBureaus.name }} Reporting and Suppression Department
                                        </p>
                                        <p>
                                            <strong>PER THE FAIR CREDIT REPORTING ACT Section § 605A 15 U.S.C. § 1681c-1:</strong> I am sending you this letter to initiate my request for your company to place a security freeze and surpress any sharing of information about myself, as <strong>{{ userInfo.firstname }} {{ userInfo.lastname }}</strong>.
                                        </p>
                                        <p>
                                            I do not consent nor authorize the sharing of my information to the public, specifically with data aggregators who are looking to collect information on my behalf. I would like to have my entire credit profile reviewed from your data institution.
                                            <br /> Please complete my following requests:
                                        </p>
                                        <ol>
                                            <li>
                                                Provide a complete overview, set of documents, procedures and snapshot of my character including any credit related information to my address listed in this document.
                                            </li>
                                            <li>
                                                Place a <strong>Security Freeze</strong> and suppress from sharing any information about me to any other parties, unless otherwise expressly permitted by me in writing.
                                            </li>
                                            <li>
                                                Once confirmed, kindly write back no later than <strong>(5) days</strong> to confirm that you have in fact, placed a security freeze on my information as well as provide me with the information needed to verify the details of my information suppression.
                                            </li>
                                        </ol>
                                        <p> My information is clearly shown below: </p>
                                        <p>
                                            <strong>FULL NAME:</strong> {{ userInfo.firstname }} {{ userInfo.lastname }}
                                            <br /> <strong>PHONE:</strong> {{ userInfo.phone }}
                                            <br /> <strong>SOCIAL SECURITY NUMBER: </strong> {{ userInfo.ssn }}
                                            <br /> <strong>FULL CURRENT ADDRESS: </strong> {{ userInfo.address }} {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                                        </p>
                                        <p>
                                            After this credit freeze has been filed, please send me written confirmation to the address listed above.
                                            <br />
                                            <br />
                                            Sincerely,
                                        </p>
                                        <p style="page-break-before: always; padding-top: 1rem; text-align: center;">
                                            <strong>
                                                Note: Attached you will find my drivers license. Please do not retain on record. Upon confirmation of my identity, you will need to purge the copy of the Drivers License attached. I do not authorize your company to store or share <strong>any</strong> of my Personal Identification.
                                            </strong>
                                        </p>
                                        <h1 style="text-align: center;">Personal Information</h1>
                                        <p style="padding-top: 1rem; text-align: center;">
                                            <img v-if='userInfo.ssn_image_url' v-bind:src='userInfo.ssn_image_url' width='300' height='200' />
                                            <img v-if='userInfo.identity_image_url' v-bind:src='userInfo.identity_image_url' width='300' height='200' />
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-primary m-1" type="submit">Create Letter</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed } from 'vue'
  import { ref } from 'vue'
  import { useUserStore } from '../../stores/UserStore.js'  
  export default {
    props: {
        routes: {
            type: [Array, Object]
        },
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        propUserInfo: {
            type: [Array, Object]
        },
    },
    components: {},
    setup(props) {
        const date = ref(null);
        return {
            creditBureaus: props.propCreditBureaus,
            userInfo: props.propUserInfo,
            date,
            userStore: useUserStore()
        };
    },
    created() {
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data))
    },
    computed: {
    },
    methods: {
    }
  };
</script>